export const ProductCardDiscountChip = ({ percent }: { percent: number }) => {
  return (
    <div
      data-test="product-card-discount"
      className="-mr-2 rounded-l-sm bg-red-200 px-2 py-0.5 text-sm font-bold text-red-600 lg:mr-0 lg:rounded-sm xl:py-px xl:text-base"
    >
      -{percent}%
    </div>
  );
};
